import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"

const ImageSliderWithContent = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const swiperRef = useRef(null)

  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }

  if (module.hideSection === "no") {
    return (
      <section className="bg-white-100">
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`zigzag-slider py-55 lgscreen:py-25 lgscreen:pb-30 ${
            module.extraClass
              ? `
    ${module.extraClass}`
              : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid"
          >
            <div className="flex flex-wrap items-center">
              <div
                className={`w-[55%] lgscreen:w-full ${
                  module.imagePosition === "right"
                    ? "order-2 lgscreen:order-1"
                    : ""
                }`}
              >
                <motion.div variants={animFade} className="relative">
                  {module?.images && (
                    <Swiper
                      ref={swiperRef}
                      spaceBetween={30}
                      loop={true}
                      slidesPerView={"1"}
                      speed={1500}
                      pagination={{ clickable: false }}
                      breakpoints={{
                        0: { slidesPerView: 1 },
                        641: { slidesPerView: 1 },
                        1024: { slidesPerView: 1 },
                      }}
                      modules={[Navigation]}
                      className={
                        module.imagePosition === "right"
                          ? "right-slider"
                          : "left-slider"
                      }
                    >
                      {module.images.map((item, i) => (
                        <SwiperSlide key={i}>
                          {item?.image && (
                            <div className="img relative">
                              <ImageOpt
                                imgData={item.image.mediaItemUrl}
                                imgAlt={item.image.altText}
                                width={1000}
                                height={800}
                                imgLoad="lazy"
                              />
                            </div>
                          )}
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}

                  <div className="swiper-arrow arrow-big flex gap-x-5">
                    <button
                      className="absolute left-25 lgscreen:left-20 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                      onClick={() =>
                        handlePrevClick(
                          `.zigzag-slider .${module.imagePosition}-slider`
                        )
                      }
                    >
                      <img
                        src="../images/slider-arrow.svg"
                        width={42}
                        height={42}
                        loading="lazy"
                        alt="Arrow"
                      />
                    </button>
                    <button
                      className="absolute right-25 lgscreen:right-20 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                      onClick={() =>
                        handleNextClick(
                          `.zigzag-slider .${module.imagePosition}-slider`
                        )
                      }
                    >
                      <img
                        src="../images/slider-arrow.svg"
                        width={42}
                        height={42}
                        className="scale-x-[-1]"
                        loading="lazy"
                        alt="Arrow"
                      />
                    </button>
                  </div>
                </motion.div>
              </div>
              <div
                className={`w-[45%] lgscreen:w-full  lgscreen:pt-30 ${
                  module?.imagePosition === "right"
                    ? "order-1 lgscreen:order-2"
                    : ""
                }`}
              >
                <div className="zigzag-content px-110 laptop:px-50 lgscreen:px-0">
                  {module?.heading && (
                    <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                  )}
                  {module?.location && (
                    <motion.div
                      variants={animFade}
                      className="flex flex-wrap gap-x-[5px] pt-10"
                    >
                      <img
                        src="../images/location-black.svg"
                        width={16}
                        height={16}
                        loading="lazy"
                        alt="Location"
                      />

                      <span className="font-ositalic text-13">
                        {module.location}
                      </span>
                    </motion.div>
                  )}
                  {module?.description && (
                    <motion.div variants={animFade} className="content pt-15">
                      {parse(module.description)}
                    </motion.div>
                  )}

                  <div className="flex flex-wrap gap-x-2 mt-30 gap-y-2">
                    {module?.book && (
                      <motion.div
                        variants={animFade}
                        className="mdscreen:w-full"
                      >
                        <Link
                          to={module.book.url}
                          target={module.book.target}
                          className="btn btn-black"
                        >
                          {module.book.title}
                        </Link>
                      </motion.div>
                    )}
                    {module?.visitSite && (
                      <motion.div
                        variants={animFade}
                        className="mdscreen:w-full"
                      >
                        <Link
                          to={module.visitSite.url}
                          target={module.visitSite.target}
                          className="btn btn-border flex flex-wrap items-center gap-x-2"
                        >
                          {module.visitSite.title}
                          {module?.visitSite.target === "_blank" && (
                            <img
                              src="../images/open-in-new.svg"
                              width={12}
                              height={18}
                              loading="lazy"
                              alt="Open in New Tab"
                            />
                          )}
                        </Link>
                      </motion.div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default ImageSliderWithContent
export const PageImageSliderWithContentFragment = graphql`
  fragment PageImageSliderWithContentFragment on WpPage_Pagecontent_PageContent_ImageSliderWithContent {
    extraId
    extraClass
    hideSection
    description
    heading
    location
    imagePosition
    images {
      image {
        altText
        mediaItemUrl
      }
    }
    book {
      target
      title
      url
    }
    visitSite {
      target
      title
      url
    }
  }
`
